"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadHelper = void 0;
const events_1 = require("../../../events");
class FileUploadHelper {
    static validateCsvFile(file) {
        if (!file.filename.toLowerCase().endsWith('.csv')) {
            return { isValid: false, error: 'Please select a valid CSV file' };
        }
        const maxSize = 10 * 1024 * 1024; // 10MB
        if (file.size > maxSize) {
            return { isValid: false, error: 'File size must be less than 10MB' };
        }
        return { isValid: true };
    }
    static async processFileUpload(file, fileProcessingService, validationService) {
        const content = await fileProcessingService.uploadFile(file);
        const data = await fileProcessingService.parseCSV(content);
        const validation = validationService.validateData(data);
        const statistics = validationService.calculateDataStatistics(data);
        return { data, validation, statistics };
    }
    static createDefaultDataStatistics() {
        return {
            totalSamples: 0,
            averageInputLength: 0,
            averageOutputLength: 0,
            categories: [],
            qualityScore: 0
        };
    }
    static emitFileUploadEvents(emit, file, data, validation, statistics) {
        emit(events_1.trainerEvents.fileUploaded, {
            file,
            data,
            validation,
            statistics
        });
        if (validation.isValid) {
            emit(events_1.trainerEvents.uploadSuccess, {
                message: `Successfully processed ${data.length} training samples from ${file.filename}`
            });
        }
        else {
            emit(events_1.trainerEvents.uploadWarning, {
                message: `File processed with warnings: ${validation.warnings.join(', ')}`
            });
        }
    }
}
exports.FileUploadHelper = FileUploadHelper;
